import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BannerComponent } from './banner.component';
import { DragulaModule, DragulaService } from 'ng2-dragula';
import { SharedModule } from '../shared/shared.module';
import { BannerCreateComponent } from './banner-create/banner-create.component';
import { BannerEditComponent } from './banner-edit/banner-edit.component';
import { BannerFormComponent } from './shared/banner-form/banner-form.component';
import { BannerCategoriesComponent } from './banner-categories/banner-categories.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    DragulaModule
  ],
  declarations: [BannerComponent, BannerCreateComponent, BannerEditComponent, BannerFormComponent, BannerCategoriesComponent],
  providers: [DragulaService]
})
export class BannerModule { }



// WEBPACK FOOTER //
// ./src/app/banner/banner.module.ts